import axios from "axios";
import { defineStore } from "pinia";

export const useCategoryStore = defineStore("category", {
  state: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    categories: [],
    response: {
      status: null,
      message: null,
      list: [],
    },
    nameQuery: "",
    current: 1,
    perpage: 10,
    totalData: 0,
  }),
  actions: {
    async changePage(newPage) {
      this.current = newPage;
    },

    async searchUsers(query) {
      this.nameQuery = query;
      this.current = 1;
    },

    async getCategories() {
      const params = new URLSearchParams({
        current: this.current,
        per_page: this.perpage,
      });

      if (this.nameQuery) params.append("name", this.nameQuery);
      if (this.slugQuery) params.append("slug", this.slugQuery);

      try {
        const res = await axios.get(`${this.apiUrl}/api/v1/categories`, {
          params,
        });

        this.categories = res.data.data.list;
        this.totalData = res.data.data.meta.total;
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
        };
      }
    },

    async addCategory(data) {
      try {
        const res = await axios.post(`${this.apiUrl}/api/v1/categories`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async updateCategory(data) {
      try {
        await axios.put(`${this.apiUrl}/api/v1/categories`, data);

        this.response = {
          status: "200",
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },

    async deleteCategory(id) {
      try {
        const res = await axios.delete(
          `${this.apiUrl}/api/v1/categories/${id}`
        );

        this.response = {
          status: res.status,
          message: res.data.message,
        };
      } catch (error) {
        this.response = {
          status: error.response?.status,
          message: error.message,
          list: error.response.data.errors,
        };
      }
    },
  },
});
